import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { User } from '@angular/fire/auth';
import { Router, RouterModule } from '@angular/router';
import { from, map, Observable, of, switchMap } from 'rxjs';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faRightFromBracket, faUser } from '@fortawesome/free-solid-svg-icons';

import { AuthService } from '../../../core/auth/auth.service';
import { isAdmin } from '../../utils/auth';

@Component({
  selector: 'app-user',
  imports: [CommonModule, FontAwesomeModule, RouterModule],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss'
})
export class UserComponent {

  //#region Font Awesome Icons
  faUser = faUser;
  faSignOut = faRightFromBracket;
  //#endregion

  //#region Properties
  adminUser$: Observable<User | null>;
  //#endregion

  //#region Authentication Materials
  #auth: AuthService = inject(AuthService);

  #router: Router = inject(Router);
  //#endregion

  //#region Constructor
  constructor() {
    this.adminUser$ = this.#auth.user$.pipe(switchMap(user => user ? from(user.getIdTokenResult()).pipe(map(credentials => isAdmin(credentials) ? user : null)) : of(null)));
  }
  //#endregion

  //#region Sign Methods
  public async onSignOut(): Promise<void> {
    // Sign out the user
    await this.#auth.signOut();

    // Redirect to sign in page
    await this.#router.navigate(['/account/auth/signIn']);
  }
  //#endregion
}
